import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import APIManager from "../services/api-manager";

export default class BlogListingBehaviour extends AbstractDataAttributeBehaviour {
  APIManager = new APIManager();

  params = {}

  attrNames = {
    'container': 'data-blog-listing',
    'wrapper': '.blog--listing-wrapper',
    'partial': 'data-blog-partial',
    'searchParams': 'data-search-params',
    'url': 'data-partial-url',
    'sortBy': 'data-blog-sort',
    'pagination': 'data-blog-pagination',
    'page': 'data-page'
  };

  getContainerSelector = () => '[' + this.attrNames.container + ']';
  getPartialSelector = () => '[' + this.attrNames.partial + ']';
  getSearchParamsSelector = () => '[' + this.attrNames.searchParams + ']';
  getSortBySelector = () => '[' + this.attrNames.sortBy + ']';
  getPaginationSelector = () => '[' + this.attrNames.pagination + ']';

  getSearchParams = () => JSON.parse(document.querySelector(this.getSearchParamsSelector()).getAttribute(this.attrNames.searchParams));

  getAjaxUrl = (container) => container.getAttribute(this.attrNames.url);

  buildUrl = url => {
    let searchParams = this.getSearchParams();
    return `${url}?${new URLSearchParams({ ...searchParams, ...this.params }).toString()}`;
  }

  scrollToTop = container => {
    window.scrollTo({
      top: container.offsetTop - 50,
      behavior: 'smooth'
    });
  }

  bindPopState = container => {
    window.addEventListener('popstate', e => {
      const ajaxUrl = this.getAjaxUrl(container);

      this.updateParamsFromUrl();
      this.fetchPartial(ajaxUrl);
    });
  }

  updateParamsFromUrl = () => {
    const searchParams = new URL(window.location.href).searchParams;

    if (Array.from(searchParams).length < 1) {
      this.params = { page: 1 }

      return;
    }

    Array.from(searchParams).map(([ key, value ]) => this.params[key] = value);
  }

  updateHistoryState = () => {
    const url = new URL(window.location.href);
    const searchParams = this.getSearchParams();

    Object.keys(searchParams).map(key => searchParams[key] && url.searchParams.set(key, searchParams[key]));
    Object.keys(this.params).map(key => url.searchParams.set(key, this.params[key]));

    window.history.pushState({ path: url.toString() },'', url.toString());
  }

  updateListing = html => {
    document.querySelector(this.getPartialSelector()).outerHTML = html;
    document.querySelector(this.attrNames.wrapper).classList.remove('loading');
    window.lazy.update();
  }

  fetchPartial = ajaxUrl => {
    document.querySelector(this.attrNames.wrapper).classList.add('loading');

    this.APIManager.getPartial(
      this.buildUrl(ajaxUrl),
      this.updateListing,
      () => {
        console.error('Something went wrong paginating the listing.')
      },
      false
    );
  }

  initContainer = (container) => {
    const ajaxUrl = this.getAjaxUrl(container);

    this.bindPopState(container);

    document.addEventListener('change', e => {
      if (e.target.matches(this.getSortBySelector())) {
        e.preventDefault();

        this.params.sortBy = e.target.options[e.target.selectedIndex].value.split(',')[0];
        this.params.sortWay = e.target.options[e.target.selectedIndex].value.split(',')[1];
        this.params.page = 1;
        this.fetchPartial(ajaxUrl);
        this.updateHistoryState();
        this.scrollToTop(container);
      }
    });

    document.addEventListener('click', e => {
      if (e.target.matches(this.getPaginationSelector())) {
        e.preventDefault();

        this.params.page = e.target.getAttribute(this.attrNames.page);
        this.fetchPartial(ajaxUrl);
        this.updateHistoryState();
        this.scrollToTop(container);
      }
    });
  }
}